/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OfferOrderActionEnum = 'Send' | 'Edit' | 'Correct' | 'ReplaceAttachment' | 'Delete' | 'Deactivate' | 'Activate' | 'Cancel' | 'Upgrade' | 'Reassign' | 'UpdateOfferOrderNumber';

export const OfferOrderActionEnum = {
    Send: 'Send' as OfferOrderActionEnum,
    Edit: 'Edit' as OfferOrderActionEnum,
    Correct: 'Correct' as OfferOrderActionEnum,
    ReplaceAttachment: 'ReplaceAttachment' as OfferOrderActionEnum,
    Delete: 'Delete' as OfferOrderActionEnum,
    Deactivate: 'Deactivate' as OfferOrderActionEnum,
    Activate: 'Activate' as OfferOrderActionEnum,
    Cancel: 'Cancel' as OfferOrderActionEnum,
    Upgrade: 'Upgrade' as OfferOrderActionEnum,
    Reassign: 'Reassign' as OfferOrderActionEnum,
    UpdateOfferOrderNumber: 'UpdateOfferOrderNumber' as OfferOrderActionEnum
};

